module.exports = __webpack_public_path__ + "img/arrow.23752b45.png";